import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentMethod } from "../../models/payment-method.model";
import { CrudService } from "./crud.service";

@Injectable({
  providedIn: "root",
})
export class PaymentMethodService {
  constructor(private crudService: CrudService) {}

  /**
   * Get all payout methods for the current driver
   */
  getAllPaymentMethods(): Observable<PaymentMethod[]> {
    return this.crudService.getData("RecebimentoMotorista") as Observable<
      PaymentMethod[]
    >;
  }

  /**
   * Get a specific payment method by ID
   */
  getPaymentMethodById(id: string): Observable<PaymentMethod> {
    return this.crudService.getData(
      "RecebimentoMotorista",
      id
    ) as Observable<PaymentMethod>;
  }

  /**
   * Create a new payment method
   */
  createPaymentMethod(paymentMethod: PaymentMethod): Observable<any> {
    return this.crudService.postData(
      "RecebimentoMotorista",
      undefined,
      paymentMethod
    );
  }

  /**
   * Update an existing payment method
   */
  updatePaymentMethod(
    id: string,
    paymentMethod: PaymentMethod
  ): Observable<any> {
    return this.crudService.putData(
      `RecebimentoMotorista/${id}`,
      paymentMethod
    );
  }

  /**
   * Delete a payment method
   */
  deletePaymentMethod(id: string): Observable<any> {
    return this.crudService.deleteData(`RecebimentoMotorista`, id);
  }
}
